import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.link.js";
import { defineComponent as _defineComponent } from 'vue';
import { useProductWishlistStore } from '~/composables/_next/stores/useProductWishlistStore';
import useIsHome from '~/composables/useIsHome';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useBooxi } from '~/composables/_next/useBooxi';
import { useWorkshop } from '~/composables/_next/useWorkshop';
import { useLocalization } from '~/composables/_next/useLocalization';
import Tooltip from '~/components/Layout/ToolTip.vue';
import useShippingCountry from '@/composables/useShippingCountry';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import SidebarMenuOrganism from '~/components/_next/organisms/SidebarMenuOrganism.vue';
import SearchOverlayOrganism from '~/components/_next/organisms/search/SearchOverlayOrganism.vue';
import StoreLocaleSelector from '~/components/Layout/StoreLocaleSelector/StoreLocaleSelector.vue';
import Logo from '~/components/ui/Logo.vue';
import BasketIcon from '~/components/ui/BasketIcon.vue';
import IconBadge from '~/components/ui/IconBadge.vue';
import CartPopup from '~/components/Layout/Cart/CartPopup/CartPopup.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeaderGraphql',
  props: {
    menuItems: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var _useShippingCountry = useShippingCountry(),
      currentCountry = _useShippingCountry.country,
      setShippingCountry = _useShippingCountry.setShippingCountry;
    var _useUiState = useUiState(),
      isCartPopupOpen = _useUiState.isCartPopupOpen;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin,
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useUiHelpers = useUiHelpers(),
      getFacetsFromURL = _useUiHelpers.getFacetsFromURL;
    var _useProductWishlistSt = useProductWishlistStore(),
      productWishlist = _useProductWishlistSt.productWishlist;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile,
      isTablet = _useMobileObserver.isTablet;
    var _useBooxi = useBooxi(),
      loadBooxi = _useBooxi.loadBooxi,
      openBooxi = _useBooxi.openBooxi;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers,
      i18n = _useNuxt2App.i18n;
    var router = useRouter();
    var route = useRoute();
    var _useLocalization = useLocalization(),
      country = _useLocalization.country;
    var _useIsHome = useIsHome(),
      isHome = _useIsHome.isHome;
    var _useWorkshop = useWorkshop(),
      checkAndAddWorkshopToCart = _useWorkshop.checkAndAddWorkshopToCart;
    var sidebarMenuRef = ref(null);
    var isSearchOpen = ref(false);
    var isSpecialShippingCountry = computed(function () {
      var _currentCountry$value;
      var countryCode = (_currentCountry$value = currentCountry.value) !== null && _currentCountry$value !== void 0 ? _currentCountry$value : '';
      return ['FR', 'BE'].includes(countryCode);
    });
    var isOpenBooking = computed(function () {
      return route.query.booking || false;
    });
    var isSearchPage = computed(function () {
      var _route$name$startsWit, _route$name;
      return (_route$name$startsWit = route === null || route === void 0 ? void 0 : (_route$name = route.name) === null || _route$name === void 0 ? void 0 : _route$name.startsWith('search-term___')) !== null && _route$name$startsWit !== void 0 ? _route$name$startsWit : false;
    });
    var term = ref(getFacetsFromURL(country).phrase);
    var wishlistTotalItems = computed(function () {
      var _productWishlist$valu, _lineItems$filter;
      var lineItems = ((_productWishlist$valu = productWishlist.value) === null || _productWishlist$valu === void 0 ? void 0 : _productWishlist$valu.lineItems) || [];
      return ((_lineItems$filter = lineItems.filter(function (item) {
        return item === null || item === void 0 ? void 0 : item.productId;
      })) === null || _lineItems$filter === void 0 ? void 0 : _lineItems$filter.length) || 0;
    });
    var handleAccountClick = function handleAccountClick() {
      navigateToOrLogin({
        nextRoutePath: {
          name: 'my-account'
        },
        previousRoutePath: route.path
      });
    };
    var handleWishlistClick = function handleWishlistClick() {
      navigateToOrLogin({
        nextRoutePath: {
          name: 'my-account-wishlist'
        },
        previousRoutePath: route.path
      });
    };
    onMounted(function () {
      if (isOpenBooking.value === 'true') {
        bookNow({
          activeReservation: !!route.query.country,
          link: true
        });
      }
    });
    var mobileMenuClick = function mobileMenuClick() {
      sidebarMenuRef.value.sidebarRef.sidebar.showModal();
      $trackers.gtm.pushEvent('mobile_burger_click', {
        event_label: 'mobile_burger_click',
        event_name: 'mobile_burger_click',
        device: isTablet.value ? 'tablet' : 'mobile'
      });
    };
    var openSearchOverlay = function openSearchOverlay() {
      isSearchOpen.value = true;
    };
    var goToOurWorkShop = function goToOurWorkShop() {
      router.push(app.localePath({
        name: 'legacy-Basic-slug',
        params: {
          slug: i18n.t('route.workshop')
        }
      }));
    };
    var goToSurvey = function goToSurvey() {
      router.push(app.localePath({
        name: 'legacy-GenericCategory-GenericCategory',
        params: {
          slug: i18n.t('route.survey')
        }
      }));
    };

    /**
     * Books a workshop based on the provided country and link.
     * @param {string} country - The name of the country.
     * @param {string} boolean - The link for specific shop data.
     * @returns {Promise<void>}
     */
    function bookNow(_x) {
      return _bookNow.apply(this, arguments);
    }
    function _bookNow() {
      _bookNow = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref) {
        var activeReservation, link, isAccesOfAllShop, shop, serviceTags, _route$query, _route$query2, _route$query3, bookingFlow;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              activeReservation = _ref.activeReservation, link = _ref.link;
              if (!(route.query.country && currentCountry.value !== route.query.country)) {
                _context2.next = 4;
                break;
              }
              _context2.next = 4;
              return setShippingCountry(route.query.country);
            case 4:
              if (link) {
                isAccesOfAllShop = (_route$query = route.query) === null || _route$query === void 0 ? void 0 : _route$query.isAccesOfAllShop;
                shop = (_route$query2 = route.query) === null || _route$query2 === void 0 ? void 0 : _route$query2.shop;
                serviceTags = (_route$query3 = route.query) === null || _route$query3 === void 0 ? void 0 : _route$query3.serviceTags;
              }
              if (!(route.query.country || activeReservation)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 8;
              return loadBooxi();
            case 8:
              bookingFlow = isAccesOfAllShop === 'false' ? '' : 'locations';
              openBooxi({
                shopId: shop,
                serviceTags: serviceTags,
                bookingFlow: bookingFlow,
                onClose: function onClose(booxiData) {
                  if ((booxiData === null || booxiData === void 0 ? void 0 : booxiData.bookNowStatus) === 'Booked') {
                    doActionOrLogin({
                      previousRoutePath: route.path,
                      action: function () {
                        var _action = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                          return regeneratorRuntime.wrap(function _callee$(_context) {
                            while (1) switch (_context.prev = _context.next) {
                              case 0:
                                _context.next = 2;
                                return checkAndAddWorkshopToCart(booxiData);
                              case 2:
                              case "end":
                                return _context.stop();
                            }
                          }, _callee);
                        }));
                        function action() {
                          return _action.apply(this, arguments);
                        }
                        return action;
                      }()
                    });
                  }
                }
              });
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _bookNow.apply(this, arguments);
    }
    watch(function () {
      return term.value;
    }, function (newVal, oldVal) {
      var shouldSearchBeOpened = !isMobile.value && term.value.length > 0 && (!oldVal && newVal || newVal.length !== oldVal.length && isSearchOpen.value === false);
      if (shouldSearchBeOpened) {
        isSearchOpen.value = true;
      }
    });
    return {
      __sfc: true,
      currentCountry: currentCountry,
      setShippingCountry: setShippingCountry,
      isCartPopupOpen: isCartPopupOpen,
      doActionOrLogin: doActionOrLogin,
      navigateToOrLogin: navigateToOrLogin,
      getFacetsFromURL: getFacetsFromURL,
      productWishlist: productWishlist,
      translate: translate,
      isMobile: isMobile,
      isTablet: isTablet,
      loadBooxi: loadBooxi,
      openBooxi: openBooxi,
      app: app,
      $trackers: $trackers,
      i18n: i18n,
      router: router,
      route: route,
      country: country,
      isHome: isHome,
      checkAndAddWorkshopToCart: checkAndAddWorkshopToCart,
      sidebarMenuRef: sidebarMenuRef,
      isSearchOpen: isSearchOpen,
      isSpecialShippingCountry: isSpecialShippingCountry,
      isOpenBooking: isOpenBooking,
      isSearchPage: isSearchPage,
      term: term,
      wishlistTotalItems: wishlistTotalItems,
      handleAccountClick: handleAccountClick,
      handleWishlistClick: handleWishlistClick,
      mobileMenuClick: mobileMenuClick,
      openSearchOverlay: openSearchOverlay,
      goToOurWorkShop: goToOurWorkShop,
      goToSurvey: goToSurvey,
      bookNow: bookNow,
      Tooltip: Tooltip,
      AzButton: AzButton,
      AzIcon: AzIcon,
      SidebarMenuOrganism: SidebarMenuOrganism,
      SearchOverlayOrganism: SearchOverlayOrganism,
      StoreLocaleSelector: StoreLocaleSelector,
      Logo: Logo,
      BasketIcon: BasketIcon,
      IconBadge: IconBadge,
      CartPopup: CartPopup
    };
  }
});